import React, { Component } from "react";
import PropTypes from "prop-types";


class Skeleton extends Component {
   render() {
       const {varient, width, height, count, borderRadius, lineGap, backgroundColor, className, countHorizontalGap} = this.props;
       const skeletonCount = Array.from({ length: count || 1 });
       return (
           <>
           {
               skeletonCount.map((index) => (
                   <div
                       key={index}
                       className={`skeleton ${className}`}
                       style={{
                           width,
                           height,
                           marginBottom : lineGap,
                           backgroundColor,
                           marginRight : countHorizontalGap,
                           borderRadius : borderRadius !== undefined ? borderRadius : varient === "circle" ? "50%" : "4px",
                       }}
                   ></div>
               ))
           }
           </>
       )
   }
}


Skeleton.propTypes = {
   varient : PropTypes.oneOf(["text","circle","rect","title","square","image"]),
   width : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   height : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   count : PropTypes.number,
   countHorizontalGap : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   borderRadius : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   lineGap : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   backgroundColor : PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};


Skeleton.defaultProps = {
   varient : "text",
   width : "100%",
   height : "20px",
   count : 1,
   borderRadius : "4px",
   lineGap : 0,
   countHorizontalGap : 0,
   backgroundColor: 'rgba(255, 255, 255, 0.25)'
};


export default Skeleton;